import { useMutation, useQuery } from "@tanstack/react-query";
import { ObjectId } from "mongodb";

import { ICustomQuestionGetResponse } from "@performyard/models";

import {
	createEngagementSurveyCustomQuestion,
	deleteEngagementSurveyCustomQuestion,
	getEngagementSurveyCustomQuestions,
	patchEngagementSurveyCustomQuestion,
} from "../../services";
import { SearchServiceSort } from "./search-service";

export const useEngagementSurveyCustomQuestions = (sort?: SearchServiceSort, search?: string) => {
	return useQuery({
		queryKey: ["EngagementCustomSurveyQuestions", sort, search],
		queryFn: () => getEngagementSurveyCustomQuestions(sort, search),
		meta: {
			errorMessage: "There was an error getting the engagement survey custom questions.",
		},
	});
};

export const useMutateEngagementSurveyCustomQuestion = (onSuccess: () => void, onError: () => void) => {
	return useMutation({
		mutationFn: (question: Partial<ICustomQuestionGetResponse>) => patchEngagementSurveyCustomQuestion(question),
		onSuccess: onSuccess,
		onError: onError,
	});
};

export const useDeleteEngagementSurveyCustomQuestion = (onSuccess: () => void, onError: () => void) => {
	return useMutation({
		mutationFn: (id: ObjectId) => deleteEngagementSurveyCustomQuestion(id),
		onSuccess: onSuccess,
		onError: onError,
	});
};

export const useCreateEngagementSurveyCustomQuestion = (
	onSuccess: (response?: Response) => void,
	onError: (response) => void
) => {
	return useMutation({
		mutationFn: (question: Partial<ICustomQuestionGetResponse>) =>
			createEngagementSurveyCustomQuestion(question) as Promise<Response>,
		onSuccess: onSuccess,
		onError: onError,
	});
};
